const formatDataTest = (prefix = '', text, suffix = '') =>
  `${prefix && prefix.trim()} ${text && text.trim()} ${suffix && suffix.trim()}`.replace(/\s/g, '-').toLowerCase()

export default formatDataTest
